import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row row-cols-2 g-4" }

import { ref } from "vue";
import { ElNotification } from "element-plus";
import ToolServices from "../services/ToolServices";


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockListExport',
  props: {
    criteria: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const visible = ref(false);
const isExporting = ref(false);
const from = ref<Date | null>(null);
const to = ref<Date | null>(null);



const show = () => {
  from.value = null;
  to.value = null;
  visible.value = true;
};

const doExport = async () => {
  isExporting.value = true;
  try {
    const params: Record<string, any> = { ...props.criteria };
    delete params.page;
    delete params.size;
    if (from.value) params.from = from.value.toISOString();
    if (to.value) params.to = to.value.toISOString();

    const blob = await ToolServices.exportBlockedList(params);
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    const date = new Date().toISOString().slice(0, 10);
    a.href = url;
    a.download = `blocked-list-${date}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    visible.value = false;
  } catch (e) {
    ElNotification.error({
      title: "Error",
      message: "Export failed.",
      offset: 100,
    });
  }
  isExporting.value = false;
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
    title: "Export Blocked List",
    width: "400px",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (visible.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        loading: isExporting.value,
        onClick: doExport
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("action.export")), 1)
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, { "label-position": "top" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_form_item, { label: "From" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: from.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((from).value = $event)),
                  type: "date",
                  placeholder: "Start date",
                  class: "w-100"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "To" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: to.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((to).value = $event)),
                  type: "date",
                  placeholder: "End date",
                  class: "w-100"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})